const STAGE = (process.env.REACT_APP_ENV === "development" ? "dev" : process.env.REACT_APP_ENV) || "local";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://q4ybqywn09.execute-api.eu-central-1.amazonaws.com/dev";

export const REDIRECT_URIS = {
  local: "http://localhost:3006/redirect",
  dev: "https://veranstaltungen-dev.ewe-netz.de/redirect",
  staging: "https://veranstaltungen-stage.ewe-netz.de/redirect",
  prod: "https://veranstaltungen.ewe-netz.de/redirect",
  production: "https://veranstaltungen.ewe-netz.de/redirect",
};

export const getRedirectUri = () => REDIRECT_URIS[STAGE as keyof typeof REDIRECT_URIS];
export const getBaseUrl = () => BASE_URL;
